<template>
  <div v-if="maintenanceLockAvailable" class="flex gap-2">
    <gp-btn
      v-if="maintenanceLocked && durationToUnlock < refreshWarningThreshold"
      size="sm"
      :label="t('ngp/admin_bar/maintenance_lock/refresh', { duration: humanLockTimeout })"
      :icon="faSync"
      btn-type="warning"
      :class="{ 'w-full': props.inPopup }"
      @click="acquireMaintenanceLock"
    />
    <gp-btn
      v-if="acquiringLock || maintenanceLocked"
      :label="t('ngp/admin_bar/maintenance_lock/unlock')"
      :icon="faUnlock"
      size="sm"
      btn-type="success"
      :class="{ 'w-full': props.inPopup }"
      @click="stopMaintenanceLock"
    />
    <gp-btn
      v-else
      :icon="faLock"
      :label="t('ngp/admin_bar/maintenance_lock/lock', { duration: humanLockTimeout })"
      size="sm"
      btn-type="danger"
      :class="{ 'w-full': props.inPopup }"
      @click="acquireMaintenanceLock"
    />
  </div>
</template>

<script setup lang="ts">
import { faLock, faSync, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { GpBtn } from "@gportal/uikit";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useMaintenanceStore } from "../../store/maintenance";
import { useServiceStore } from "../../store/service";

const { t } = useI18n();
const service = useServiceStore();
const maintenance = useMaintenanceStore();

const lockTimeout = computed(() => maintenance.lockTimeout);
const humanLockTimeout = computed(() => maintenance.humanLockTimeout);
const maintenanceLocked = computed(() => maintenance.maintenanceLocked);
const durationToUnlock = computed(() => maintenance.durationToUnlock);

const props = defineProps<{
  inPopup: boolean;
}>();

// Threshold below which a warning-coloured button is shown to refresh the maintenance lock
// 240 * 1000ms = 4 minutes
const refreshWarningThreshold = 240 * 1000;

const acquiringLock = ref(false);

async function acquireMaintenanceLock() {
  acquiringLock.value = true;
  try {
    await maintenance.acquireMaintenanceLock(lockTimeout.value);
  } finally {
    acquiringLock.value = false;
  }
}

async function stopMaintenanceLock() {
  await maintenance.releaseMaintenanceLock();
}

const maintenanceLockAvailable = computed(() => service.ctx.service?.config?.rsid);
</script>
